import {SetGetBonusesHistory} from './thunk/setGetBonusesHistory';
import {SetGetBonusesPersonal} from './thunk/setGetBonusesPersonal';
import {SetPostIssuePersonal} from './thunk/setPostIssuePersonal';

export const Thunks = {
    SetGetBonusesPersonal,
    SetGetBonusesHistory,
    SetPostIssuePersonal
}